import React from 'react'

import { useLocalStorageContext } from '../../contexts/LocalStorageContext'
import { HistorySearchShelf } from '../sections/HistorySearchShelf'

import type { ProductLayout } from '../../types/Product'

interface YouMayAlsoLikeShelfProps {
  data?: {
    isActive: boolean
    shelfLayout?: ProductLayout
  }
}

export const YouMayAlsoLikeShelf = ({ data }: YouMayAlsoLikeShelfProps) => {
  const { lastSearched } = useLocalStorageContext()
  const isActive = data?.isActive
  const term = lastSearched?.[0]?.text

  if (!isActive || !term) {
    return null
  }

  return <HistorySearchShelf term={term} layout={data?.shelfLayout} />
}
